import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { Payment } from '../../order.interface';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { CROSS, ALERT_FAILED } from 'src/defaultImages.js';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  orderId: string; // Add orderId property
  payments: Payment[] = []; // Add payments property
  failedPaymentsCount: number = 0;
  images = {
    CROSS,
    ALERT_FAILED,
  };
  currency:string;
  paymentFailureMessages = [
    'PAYMENT_HISTORY.PAYMENT_FAILED_FIRST',
    'PAYMENT_HISTORY.PAYMENT_FAILED_SECOND'
  ];

  constructor(
    private _translateService: TranslateService,
    private _localStorage: LocalStorageService,
    private _modal: NzModalRef,
    private _currencyService: CurrencyService,
  ) {
    this._translateService.use(this._localStorage.get('language') || 'en_US');
  }

  ngOnInit(): void {
    this.currency = this._currencyService.getCurrency();
    this.initializePayments();
  }

  initializePayments(): void {
    const paymentsArray = this.payments?.filter(payment => payment?.status === 2) || [];
    this.failedPaymentsCount = paymentsArray?.length;
  }

  closeDialog(): void {
    this._modal.destroy();
  }

  trackByPaymentId(index: number, item: any): any {
    return item?.payment_id || index;
  }
}
